import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AuthorizedPersons from '../../components/authorized-persons/AuthorizedPerson';
import { useNavigate } from "react-router";

const StepOne = ( props ) => {
    let [ load, setLoad ] = useState(false);

    let navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        if ( !load ) {
            window.scrollTo(0, 0);
            dispatch({ type: 'STEPS_CHANGE', value: 3 })
            if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
            }
            setLoad(true);
        } 
    }, [load])

    let prev = () => {
        navigate('/krok/2')
    }

    let next = () => {
        navigate('/krok/4')
    }

    return (
        <>
        <section className="form steps">
            <div className="container-step">
                <div className="row" >
                    <AuthorizedPersons prev={ () => prev() } next={ () => next() } />
                </div>
            </div>
        </section>
        </>
    )
}

export default StepOne;